import { render, staticRenderFns } from "./dialogForms.vue?vue&type=template&id=71a1b58b&scoped=true&"
import script from "./dialogForms.vue?vue&type=script&lang=js&"
export * from "./dialogForms.vue?vue&type=script&lang=js&"
import style0 from "./dialogForms.vue?vue&type=style&index=0&id=71a1b58b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1b58b",
  null
  
)

export default component.exports